import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import { FLEXIBLE_CONTENT_BASE_SPACING } from '../../../constants/flexibleContentBaseSpacing'
import { html } from '../../../utils/html'
import { FlexibleContent } from '../flexibleContent'
import { ThreeColumnRowFragment } from '@gql'
import styled from 'styled-components'
import { ColumnCard } from '../../ColumnCard/columnCard'

export type ThreeColumnRowProps = ThreeColumnRowFragment & {
  verticallyCentre: boolean
  highlightColumn: boolean
}

export const ThreeColContent = styled(Grid)`
`
export const HighlightColumn = styled(Grid)`
  background-color: ${props => props.theme.custom.colors.orange};
  border-radius: ${props => props.theme.typography.pxToRem(12)};
  padding: ${props => props.theme.typography.pxToRem(35)} ${props => props.theme.typography.pxToRem(40)};

  && ul {
    margin: 0;

    li {
      max-width: calc(100% - ${props => props.theme.spacing(2)});
      font-size: ${props => props.theme.typography.pxToRem(18)};
      font-weight: 500;
      left: ${props => props.theme.spacing(2)};

      &::before {
        padding-right: ${props => props.theme.typography.pxToRem(0)};
        left: ${props => props.theme.spacing(-2)};
      }
    }
  }
`

export const ThreeColumnRow: React.FC<PropsWithChildren<ThreeColumnRowProps>> = ({ column1, column2, column3, verticallyCentre, highlightColumn, altBg, column1AltBg, column2AltBg, column3AltBg }) => {
  const columns = [column1, column2, column3]
  const altBgColumns = [column1AltBg, column2AltBg, column3AltBg]

  highlightColumn = false

  return (
    <FlexibleContent row>
      <ColumnCard $altBg={altBg}>
        <Grid container spacing={FLEXIBLE_CONTENT_BASE_SPACING} alignItems={verticallyCentre ? 'center' : 'flex-start'}>
          {columns.map((col, i) => (
            <ThreeColContent item key={i} xs={12} md={4}>
              <ColumnCard $altBg={altBgColumns[i]}>
                {highlightColumn && i === 2 && (
                  <HighlightColumn>
                    {col && html(col)}
                  </HighlightColumn>
                )}
                {(!highlightColumn || i !== 2) && col && html(col)}
              </ColumnCard>
            </ThreeColContent>
          ))}
        </Grid>
      </ColumnCard>
    </FlexibleContent>
  )
}